module.exports = __webpack_public_path__ + "@/assets/img/examenes.da57d97f.svg";